const t={content:{maxWidth:"580px",minHeight:"260px"}},e={content:{maxWidth:"580px",minHeight:"378px"}};export{e as ExtendedSelectionModalCustomStyle,t as SelectionModalCustomStyle};
//# sourceMappingURL=selectionModalCustomStyles.js.map
